export default "__VITE_ASSET__f422e63f__"